import { createContext } from 'react';

export default createContext({
  startLoading: () => null,
  completeLoading: () => null,
  withLoader: () => null,
});
